exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.meta-list[data-v-fa60a932] {\n  margin-bottom: 30px;\n}\n.meta-item[data-v-fa60a932] {\n  margin-bottom: 10px;\n}\n.description[data-v-fa60a932] {\n  margin-bottom: 60px;\n}\n.separator[data-v-fa60a932] {\n  border: 1px solid rgb(224, 224, 224);\n  margin: 1.5em 0em;\n  border-top: none;\n}\n", ""]);

// exports
